<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${product.name}` }} - {{ $t("COMMON.SUPPLIERS") }}
      </span>
    </div>

    <supplier-list-table
      :filterByProduct="product?.id"
      :filterOrganization="product?.organization?.id"
    />
  </div>
</template>
<script>
import SupplierListTable from "../../../PurchasesModule/SupplierManagement/partials/SupplierListTable";

export default {
  name: "product-view-suppliers",

  components: {
    SupplierListTable,
  },

  props: ["product"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
